import React,{useState,useEffect,useRef} from 'react'
import Functions from './function'
import { useParams } from 'react-router-dom';
import { QRCodeCanvas } from "qrcode.react";
import Logo from '../../../images/public/websitefooter.png'
import './index.css'

const Index = () => {
    const [orderdata,setOrderData] = useState(null);
    const {id} = useParams();
    const inprint = useRef(false);
    useEffect(()=>{
        Functions.Get(id,(data)=>{
            setOrderData(data);
            if(!inprint.current){
                setTimeout(() => {
                    window.print();
                    window.close();
                }, 400);
            }
            inprint.current = true;
        });
    },[id])
  return (
    <div className='nv-label'>
    {orderdata &&
        <div className='nv-label__page'>
            <div className='nv-label__card'>
                <div className='nv-label__header'>
                    <img className='nv-label__logo' src={Logo} alt="N-Vision Dental"/>
                    <h1 className='nv-label__title'>Job Label</h1>
                </div>

                <div className='nv-label__meta'>
                    <div className='nv-label__meta-item'>
                        <span className='nv-label__k'>Invoice No</span>
                        <span className='nv-label__v'>{id}</span>
                    </div>
                    <div className='nv-label__meta-item -right'>
                        <span className='nv-label__k'>Pan No</span>
                        <span className='nv-label__v'>{orderdata.workingpan}</span>
                    </div>
                </div>

                <div className='nv-label__section'>
                    <h2 className='nv-label__heading'>To</h2>
                    <div className='nv-label__row -patient'>
                        <span className='nv-label__label'>Patient</span>
                        <span className='nv-label__value'>{orderdata.patient}</span>
                    </div>
                    <div className='nv-label__row'>
                        <span className='nv-label__label'>Doctor</span>
                        <span className='nv-label__value'>{orderdata.doctorname}</span>
                    </div>
                    <div className='nv-label__row'>
                        <span className='nv-label__label'>Clinic</span>
                        <span className='nv-label__value'>{orderdata.clinicname}</span>
                    </div>
                    <div className='nv-label__row'>
                        <span className='nv-label__label'>Address</span>
                        <span className='nv-label__value'>{orderdata.clinicaddress}</span>
                    </div>
                    <div className='nv-label__row'>
                        <span className='nv-label__label'>Email</span>
                        <span className='nv-label__value'>{orderdata.doctoremail}</span>
                    </div>
                    <div className='nv-label__row'>
                        <span className='nv-label__label'>Phone</span>
                        <span className='nv-label__value'>{orderdata.doctorcontact}</span>
                    </div>
                </div>

                <div className='nv-label__section'>
                    <h2 className='nv-label__heading'>From</h2>
                    <div className='nv-label__from'>
                        <div className='nv-label__from-info'>
                            <p className='nv-label__lab-name'>N-Vision Digital Dental Laboratory</p>
                            <p className='nv-label__lab-line'>P 369, Street #2, Block B, Alnajaf Colony, Faisalabad, Pakistan. 38000</p>
                            <p className='nv-label__lab-line'>Email: fsd@nvisiondental.com</p>
                            <p className='nv-label__lab-line'>041-8555333</p>
                        </div>
                        <div className='nv-label__qr'>
                            <QRCodeCanvas
                                id="qrCode"
                                value={id}
                                bgColor={"#ffffff"}
                                level={"H"}
                                size={72}
                            />
                        </div>
                    </div>
                </div>

                <div className='nv-label__footer'>
                    <div className='nv-label__sign'>
                        <div className='nv-label__sign-space'></div>
                        <div className='nv-label__sign-line'></div>
                        <p className='nv-label__sign-label'>Checked by</p>
                    </div>
                    <div className='nv-label__sign'>
                        <div className='nv-label__sign-space'></div>
                        <div className='nv-label__sign-line'></div>
                        <p className='nv-label__sign-label'>Delivered by</p>
                    </div>
                </div>
            </div>
        </div>
    }
    </div>
  )
}

export default Index
